import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Card } from "../common/Card";
import { ErrorRetry } from "../../common/ErrorRetry";
import { DailyRevenueShimmer } from "../../common/reportDashBShimmer/DailyRevenueShimmer";

export function FlightTrendSection({ state, trendData }) {
  return (
    <Card className="p-8 bg-white rounded-2xl shadow-lg shadow-gray-100/50 border border-gray-100 hover:shadow-xl transition-shadow duration-300">
      <div className="flex items-center justify-between mb-6">
        <div>
          <span className="text-[#1A1A1A] text-base md:text-lg mb-1">
            Monthly Revenue & Bookings Trend
          </span>
          <p className="text-sm text-[#6B7280]">
            Track revenue and booking volumes over time
          </p>
        </div>
      </div>

      {state.loading ? (
        <DailyRevenueShimmer />
      ) : state.error ? (
        <ErrorRetry message={state.message} onRetry={state.onRetry} />
      ) : trendData.length > 0 ? (
        <ResponsiveContainer width="100%" height={380}>
          <LineChart data={trendData}>
            <CartesianGrid
              strokeDasharray="3 3"
              stroke="#F3F4F6"
              vertical={false}
            />
            <XAxis dataKey="month" stroke="#9CA3AF" tick={{ fontSize: 12 }} />
            <YAxis yAxisId="left" stroke="#9CA3AF" tick={{ fontSize: 12 }} />
            <YAxis
              yAxisId="right"
              orientation="right"
              stroke="#9CA3AF"
              tick={{ fontSize: 12 }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: "white",
                border: "1px solid #E5E7EB",
                borderRadius: "12px",
                boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
              }}
            />
            <Legend wrapperStyle={{ paddingTop: "20px" }} />
            <Line
              yAxisId="left"
              type="monotone"
              dataKey="revenue"
              strokeWidth={3}
              name="Revenue (₦)"
              dot={{ r: 4 }}
              activeDot={{ r: 6 }}
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="bookings"
              strokeWidth={3}
              name="Bookings"
              dot={{ r: 4 }}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <div className="text-gray-500">No trend data available</div>
      )}
    </Card>
  );
}
